let isValidEmail = (email: string) => email.includes('@') && email.split('@')[1].includes('.')

export {
  isValidEmail
}